import {Dashboard} from "@/components";
import {Favorites} from "@/components";

export const FavoritesPage = () => (
  <Dashboard openLogIn>
    <Favorites />
  </Dashboard>
)